var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63636 9C2.28491 9 2 8.71509 2 8.36364C2 4.8491 4.84909 2 8.36363 2H15.6364C19.1509 2 22 4.8491 22 8.36364C22 8.71509 21.7151 9 21.3636 9H2.63636Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63636 15C2.28491 15 2 15.2849 2 15.6364C2 19.1509 4.84909 22 8.36363 22H15.6364C19.1509 22 22 19.1509 22 15.6364C22 15.2849 21.7151 15 21.3636 15H2.63636Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46855 10.4143C2.1451 10.1556 1.67313 10.208 1.41438 10.5315C1.15562 10.8549 1.20806 11.3269 1.53151 11.5857L2.78151 12.5857C3.78621 13.3894 5.21384 13.3894 6.21855 12.5857C6.67543 12.2201 7.32463 12.2201 7.78151 12.5857C8.78621 13.3894 10.2138 13.3894 11.2185 12.5857C11.6754 12.2201 12.3246 12.2201 12.7815 12.5857C13.7862 13.3894 15.2138 13.3894 16.2185 12.5857C16.6754 12.2201 17.3246 12.2201 17.7815 12.5857C18.7862 13.3894 20.2138 13.3894 21.2185 12.5857L22.4685 11.5857C22.792 11.3269 22.8444 10.8549 22.5856 10.5315C22.3269 10.208 21.8549 10.1556 21.5315 10.4143L20.2815 11.4143C19.8246 11.7799 19.1754 11.7799 18.7185 11.4143C17.7138 10.6106 16.2862 10.6106 15.2815 11.4143C14.8246 11.7799 14.1754 11.7799 13.7185 11.4143C12.7138 10.6106 11.2862 10.6106 10.2815 11.4143C9.82463 11.7799 9.17543 11.7799 8.71855 11.4143C7.71384 10.6106 6.28621 10.6106 5.28151 11.4143C4.82463 11.7799 4.17543 11.7799 3.71855 11.4143L2.46855 10.4143Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerAlt1);
export default __webpack_public_path__ + "static/media/burger-alt-1.53b67ab98659a90e3e3653540d8890bf.svg";
export { ForwardRef as ReactComponent };